import { render, staticRenderFns } from "./BugBounty.vue?vue&type=template&id=6c34da99&scoped=true&"
import script from "./BugBounty.vue?vue&type=script&lang=js&"
export * from "./BugBounty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34da99",
  null
  
)

export default component.exports